const ACCOUNT_ID_REGEX =
  /^Ac([a-zA-Z0-9\-_]{10,11}$|[a-zA-Z0-9\-_]{10,11}_CP[0-9]{3}$)/s;

export function getS3FileKey(keyPath, flowId) {
  // Retrieve the account ID from the window object if available, or use the provided accountDetails object.
  const accountId = window.accountDetails._id;
  // If keyPath or accountId is not provided, return the original keyPath.
  if (!keyPath || !accountId) {
    return keyPath;
  }
  // Split the keyPath by '/' to extract the first part (id).
  let id = keyPath.split("/")[0];
  // Check if the id matches a regular expression pattern (ACCOUNT_ID_REGEX).
  if (id.search(ACCOUNT_ID_REGEX) !== -1 && id !== flowId) {
    // If it does, replace the id with the account ID.
    return keyPath.replace(id, accountId);
  }
  // If it doesn't, prepend the account ID to the keyPath.
  return keyPath.startsWith("/")
    ? accountId + keyPath
    : `${accountId}/${keyPath}`;
}

export const removeAccountIdFromKey = (fileKey = "", flowId) => {
  let id = fileKey.split("/")[0];
  if (id.search(ACCOUNT_ID_REGEX) !== -1 && id !== flowId) {
    fileKey = fileKey.replace(id, "");
  }
  if (fileKey.charAt(0) === "/") {
    fileKey = fileKey.slice(1);
  }
  return fileKey;
};
